import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
// Custom deep equality function that handles BigInt
function customDeepEqual(oldData, newData) {
  // Handle BigInt comparison
  if (typeof oldData === "bigint" && typeof newData === "bigint") {
    return oldData === newData;
  }
  // Handle arrays
  if (Array.isArray(oldData) && Array.isArray(newData)) {
    return oldData.length === newData.length && oldData.every((item, index) => customDeepEqual(item, newData[index]));
  }
  // Handle objects
  if (oldData && newData && typeof oldData === "object" && typeof newData === "object") {
    const keys1 = Object.keys(oldData);
    const keys2 = Object.keys(newData);
    return keys1.length === keys2.length && keys1.every(key => customDeepEqual(oldData[key], newData[key]));
  }
  // Handle primitive values
  return oldData === newData;
}
// Hook to fetch and auto-refresh order status and transaction details
export function useAnyspendOrderAndTransactions(orderId) {
  const $ = _c(12);
  const selectFn = _temp;
  let t0;
  let t1;
  if ($[0] !== orderId) {
    t0 = ["getAnyspendOrderAndTransactions", orderId];
    t1 = () => anyspendService.getOrderAndTransactions(orderId);
    $[0] = orderId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!orderId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchInterval: 3000,
      staleTime: 1000,
      select: selectFn,
      structuralSharing: _temp2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: data_0,
    isLoading,
    refetch,
    error
  } = useQuery(t3);
  let t4;
  let t5;
  if ($[7] !== data_0 || $[8] !== error || $[9] !== isLoading || $[10] !== refetch) {
    t5 = {
      orderAndTransactions: data_0,
      isLoadingOrderAndTransactions: isLoading,
      getOrderAndTransactionsError: error,
      refetchOrderAndTransactions: refetch
    };
    $[7] = data_0;
    $[8] = error;
    $[9] = isLoading;
    $[10] = refetch;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  t4 = t5;
  return t4;
}
function _temp2(oldData, newData) {
  if (customDeepEqual(oldData, newData)) {
    return oldData;
  }
  return newData;
}
function _temp(data) {
  if (!data) {
    return;
  }
  return data;
}